import { getSession } from "~/lib/network/chat-session";
import { GamgeeChatSession } from "~/types/session";

interface CurrentSessionState {
    currentSession: GamgeeChatSession | null;
    sessionDocumentView: boolean;
    fetchCurrentSession: (sessionId: string) => Promise<void>;
    setCurrentSession: (session: GamgeeChatSession) => void;
    reset: () => void;
}

const defaultState: CurrentSessionState = {
    currentSession: null,
    sessionDocumentView: false,
    fetchCurrentSession: async () => {},
    setCurrentSession: () => {},
    reset: () => {},
};

export const createCurrentSessionSlice = (set: any, get: any, storeApi: any) => {
    return {
        ...defaultState,
        fetchCurrentSession: async (sessionId: string) => {
          const currentSession = await getSession(sessionId);
          set((state: CurrentSessionState) => ({ currentSession: currentSession }));
        },
        setCurrentSession: (session: GamgeeChatSession) => {
          set((state: CurrentSessionState) => ({ currentSession: session }));
        },
        setSessionDocumentView: (isOpen: boolean) => {
          set((state: CurrentSessionState) => ({ sessionDocumentView: isOpen }));
        },
        reset: () => set(defaultState),
    }
}
